var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "25",
        height: "24",
        viewBox: "0 0 25 24",
        fill: "none",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M13.6154 6.82679L6.34208 14.1032C6.01896 14.4264 5.78278 14.8272 5.65226 15.2654L4.54602 19.0247C4.46949 19.2849 4.53992 19.5634 4.72958 19.753C4.91926 19.9427 5.19771 20.0131 5.45481 19.9397C5.45483 19.9397 5.45485 19.9397 5.45487 19.9397L9.21407 18.8335L13.6154 6.82679ZM13.6154 6.82679L17.6558 10.8672L10.3762 18.1436C10.0531 18.4668 9.65229 18.7029 9.21412 18.8334L13.6154 6.82679ZM19.8856 5.83135L19.8856 5.83136C20.6608 6.60651 20.6608 7.86224 19.8856 8.63739L18.3842 10.1388L14.3438 6.09844L15.8373 4.60491V4.60803L15.8483 4.59699C16.6235 3.82184 17.8792 3.82184 18.6543 4.59697L18.6544 4.59699L19.8856 5.83135Z",
          fill: "#010A11",
          stroke: "#333333",
          "stroke-width": "0.03125",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }